export default {
  label: 'Lähetä vastaanottajille',
  counter: '{{current}} / {{max}}',
  default_badge: 'Oletus',
  remove: 'Poista {{email}}',
  add_back: 'Lisää takaisin',
  empty: 'Lisää vähintään yksi sähköpostiosoite.',
  add_label: 'Lisää sähköpostiosoite',
  placeholder: 'nimi@example.com',
  add: 'Lisää',
  hint: 'Enintään {{max}} sähköpostiosoitetta. Jokainen saa oman sähköpostinsa.',
  hint_full: 'Lista on täynnä. Poista osoite, jos haluat lisätä uuden.',
  errors: {
    full: 'Voit lisätä enintään {{max}} sähköpostiosoitetta.',
    invalid: 'Anna sähköpostiosoite muodossa nimi@example.com.',
    duplicate: '{{email}} on jo listalla.',
  },
};
